/* eslint @typescript-eslint/naming-convention: 0 */
import type { ExperienceSortType } from '@/wabunka-src/common/features/Experience/utils/experienceListSort';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface SelectExperienceInListParams {
  sort_type: ExperienceSortType;
  /** 遷移先の体験 slug */
  clicked_slug: string;
  /** ページ内での表示順位（1 始まり） */
  position: number;
}

export interface SelectExperienceInListInput {
  sortType: ExperienceSortType;
  clickedSlug: string;
  position: number;
}

const buildSelectExperienceInListParams = (input: SelectExperienceInListInput): SelectExperienceInListParams => {
  return {
    sort_type: input.sortType,
    clicked_slug: input.clickedSlug,
    position: input.position,
  };
};

/**
 * 発火タイミング：一覧のカードをクリックして体験詳細へ遷移した際。
 * ※ view_experience_list と対で、ソート別の一覧→詳細遷移率の分子に使う。
 */
export const sendGAWabunkaSelectExperienceInListEvent = (input: SelectExperienceInListInput) => {
  sendWabunkaGAEvent('select_experience_in_list', buildSelectExperienceInListParams(input));
};
